export default __webpack_public_path__ + "static/media/Waybill.926b3e0d.svg";